exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".warn[data-v-ee039356]{color:red}.heading[data-v-ee039356]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.md-fab[data-v-ee039356]{margin-left:auto}.rightAlign[data-v-ee039356]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ee039356","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/ConsentEditor.vue
// module id = 396
// module chunks = 0